/** 委外实时分拣数量查询——列表*/
export const SORTINGDATA_QUERY_LIST = {
  url: 'entrust/sorting/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 委外实时分拣数量查询——导出*/
export const SORTINGDATA_QUERY_EXPORT = {
  url: 'entrust/sorting/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
